module.exports = __webpack_public_path__ + "static/electronics-a4e76ef76a0b515c013b81037c7d5c42.svg";